import { render } from "./CommonView.vue?vue&type=template&id=63802115&scoped=true"
import script from "./CommonView.vue?vue&type=script&lang=js"
export * from "./CommonView.vue?vue&type=script&lang=js"

import "./CommonView.vue?vue&type=style&index=0&id=63802115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63802115"]])

export default __exports__